import { render, staticRenderFns } from "./team-members-list-member-entry.vue?vue&type=template&id=0d958f02&scoped=true&"
import script from "./team-members-list-member-entry.vue?vue&type=script&lang=ts&"
export * from "./team-members-list-member-entry.vue?vue&type=script&lang=ts&"
import style0 from "./team-members-list-member-entry.vue?vue&type=style&index=0&id=0d958f02&lang=scss&scoped=true&"
import style1 from "./team-members-list-member-entry.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d958f02",
  null
  
)

export default component.exports